import {
  IMeeetingAgenda,
  TComplexSectionData,
} from 'legacy/lut/classes/models/partner360/ELT/IELTFormData'
import { useEffect } from 'react'

import { getChangedAgendaSchedule } from '../helpers/getChangedAgendaSchedule'

interface IProps {
  meetingDateTime: string
  updateFormData: (data: TComplexSectionData) => void
  data: IMeeetingAgenda[]
}

export const useSubscribeOnMeetingTime = ({ meetingDateTime, data, updateFormData }: IProps) => {
  useEffect(() => {
    updateFormData(getChangedAgendaSchedule(meetingDateTime, data))
  }, [meetingDateTime])
}
